const PATHS = {
  ABOUT: "/about",
  ACHIEVEMENTS: "/achievements",
  AWARDS: "/awards",
  EDUCATION: "/education",
  EXPERIENCE: "/experience",
  HOME: "/",
  PAPERS: "/papers",
  PROJECTS: "/projects",
};

export { PATHS };
